var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.$device.isMobileOrTablet)?_c('a',{attrs:{"type":"button","target":"_blank","href":`mailto:?subject=${_vm.title}&body=${_vm.fullUrl}`}},[_c('SaIcon',{attrs:{"name":"email-solid"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }